<template>
  <div class="swiper">
    <swiper
      :options="swiperOption"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide class="swiper_slide" v-for="(t, i) in videoList" :key="i">
        <div v-if="isModel" class="left_module_one">
          <!-- <div class="left_module_one_top" @click.stop="">
            <div class="left_module_one_top-state">
              <img :src="`${t.livetime*1000<=new Date().getTime()?btn1:btn2}`" alt="">
              <img :src="btn1" alt="">
              <a href="https://live.photoplus.cn/live/67049967">
                <img src="@/assets/state4.png" alt="">
              </a>
            </div>
          </div> -->
          <div class="left_module_one-desc">{{ t.title }}</div>
          <div class="left_module_one_top-date">
            <span
              >{{ $moment(t.livetime * 1000).format('MM月DD日') }}
              {{ t.address }}</span
            >
          </div>
        </div>
        <div v-else class="module_two">
          <div class="module_two-left">
            <div class="module_two-left-state">
              <!-- <img :src="`${t.livetime*1000<=new Date().getTime()?btn1:btn2}`" alt=""> -->
              <img :src="btn1" alt="" />
              <a href="https://live.photoplus.cn/live/1075855">
                <img
                  src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_85417859f4b347c48156f702369bc692.png"
                  alt=""
                />
              </a>
            </div>
            <div class="module_two-left-desc">
              {{ t.title }}
            </div>
            <div class="module_two-left-date">
              <img src="https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_8e738a55d31244c38fbce8b86af13124.png" alt="" />
              <div class="module_two-left-date-box">
                <div class="module_two-left-date-box-text">
                  {{ $moment(t.livetime * 1000).format('MM月DD日') }}
                </div>
                <div class="module_two-left-date-box-text">{{ t.address }}</div>
              </div>
            </div>
          </div>
          <div class="module_two-right">
            <img src="@/assets/img2.png" alt="" />
            <div class="module_two-right-kv">
              <img :src="t.kvImg" alt="" />
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- <div class="swiper-pagination"></div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div> -->
  </div>
</template>

<script>
let that = null
export default {
  created() {
    that = this
  },
  data() {
    return {
      isModel: null,
      swiperOption: {
        slidesPerView: 1,
        grabCursor: true,
        // autoHeight: true,
        spaceBetween: 50,
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        on: {
          tap: function (e) {
            var index = e.realIndex
            var item = that.videoList[index]
            that.selectLive(item)
          }
        }
      },
      btn1: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_25d5691d023f42ac8bd849b5210ab0a7.png',
      btn2: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_76e064923d3c4e448c3ea310ceca1d5e.png',
      slider: []
    }
  },
  props: {
    videoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isShow: {
      type: Boolean,
      default: false
    },
    liveId: {
      type: Number || String,
      default: null
    }
  },
  // watch: {
  //   videoList(n) {

  //   }
  // },
  mounted() {
    this.isModel = this.$isModel()
  },
  methods: {
    // 选择直播
    selectLive(data) {
      console.log(data.liveId)
      this.$emit('update:liveId', data.liveId)
    },
    h() {
      console.log('vvv')
    },
    playVideo() {
      console.log('ok')
      this.$emit('update:isShow', true)
    },
    onSwiper() {},
    onSlideChange() {}
  }
}
</script>

<style lang="scss" scoped>
$left-logo-padding-top: 0.6rem;
$margin-left_one: 0.4rem;
$margin-right_one: 35px;
$margin_bottom_one: 30px;
$padding_top_one: 32px;
$module-two-margin-bottom: 0.4rem;
$width_left: 5.3rem;
$width_all: 5.7rem;
$width_right-logo: 10.56rem;
$width_video: 10.92rem;
$width_right: 11.9rem;
$color_f: #fff;
$color_a: #a6939a;
$module_two-left-width: 1.3rem;
.swiper {
  width: 100%;
}
.swiper_slide {
  img {
    width: 100%;
  }
}
.left_module_one {
  &_top {
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 0.07rem;
    &-state {
      display: flex;
      width: 3.6rem;

      img {
        width: 1.65rem;
      }
      // margin-right: 20px;
    }
    &-date {
      font-size: 0.28rem;
      margin-top: 0.1rem;
    }
  }
  &-desc {
    font-size: 0.28rem;
    text-align: justify;
    letter-spacing: 2px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    -webkit-line-clamp: 2; //显示几行
  }
}
.module_two {
  margin: auto;
  display: flex;
  justify-content: space-between;
  &-left {
    width: $module_two-left-width;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-grow: 1;
    padding-bottom: 0.08rem;
    justify-content: space-between;
    &-state {
      display: flex;
      justify-content: space-between;
      height: 0.3rem;
      img {
        height: 100%;
        width: auto;
      }
    }
    &-desc {
      color: $color-f;
      text-align: justify;
      font-size: 0.12rem;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      line-clamp: 3;
      -webkit-line-clamp: 3; //显示几行
    }
    &-date {
      position: relative;
      // box-shadow: 3px 3px 4px #000;
      &-box {
        box-sizing: border-box;
        padding: 0 0.1rem;
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        justify-content: space-around;
        align-items: center;
        &-text {
          color: #3f0e77;
          line-height: 1;
          font-size: 0.12rem;
        }
      }
    }
  }
  &-right {
    margin-left: 0.1rem;
    position: relative;
    width: 2rem;
    &-kv {
      width: 92%;
      position: absolute;
      top: 0;
      left: 7%;
    }
  }
}
</style>
